import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LockScreen from "./components/LockScreen";
import Home from "./components/Home";
import Savings from "./components/Savings";
import Dashboard from "./components/Dashboard";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LockScreen />} />
        <Route path="/home" element={<Home />} />
        <Route path="/savings" element={<Savings />} />
        <Route path="/dashboard" element={<Dashboard />} />
      </Routes>
    </Router>
  );
}

export default App;
